import React from 'react';
import {
	TextField, FormControl, Box, Grid
} from '@mui/material';
import { NumericFormat } from "react-number-format";
import CustomPopover from "../../../../calculations/components/popovers/customPopover.js";
import LazyAutocomplete from './lazyAutocomplete.js';
import useUserData from "../../../../../../src/hooks/user/useUserData.js";

const DynamicFormField = ({ formFields, formErrors, setFormFields }) => {
	const userData = useUserData()
	const language = userData.language
	

	console.log('formFields');
	console.log(formFields);
	console.log('formFields');
	

	const handleChange = (fieldIndex, newValue) => {
		if (setFormFields) {
			setFormFields(prev => {
				const copy = [...prev];
				copy[fieldIndex] = {
					...copy[fieldIndex],
					Value: newValue
				};
				return copy;
			});
		}
	};

	const handleOnBlur = () => {
		// Handle blur if needed
	};

	const renderPopover = (field) => {
		if (!field.popover && !field.DescriptionEl) return null;
		return (
			<Box className="label-popover">
				<CustomPopover
					className={'color-default p-xsfs'}
					id={field.QuestionId}
					title={(language === 'en' ? field.DescriptionEn : field.DescriptionEl)}
					content={field?.popover?.content ? field.popover.content : (language === 'en' ? field.InfoEN : field.InfoEL)}
					isOpen={false}
					setIsOpen={() => {}}
					isLtv={false}
					handleNext={() => {}}
				/>
			</Box>
		);
	};

	return (
		<Box className="property-search-form">
			<Grid container   columnSpacing={5}>
				{formFields?.map((field, index) => {
					const currentLanguage = language;
					
					// Determine field type based on TypeId
					let fieldType = 'text';
					if (field.TypeId === '2') {
						fieldType = 'number';
					} else if (field.TypeId === '4') {
						fieldType = 'list';
					}
					
					const commonProps = {
						name: (''),
						value: field.Value || '',
						size: 'small',
						fullWidth: true,
						error: !!formErrors?.[field.QuestionId],
						helperText: formErrors?.[field.QuestionId],
						disabled: false,
						onBlur: () => {
							handleOnBlur();
						}
					};

					switch (fieldType) {
						case 'text':
						case 'email':
							return (
								<Grid item xs={12} md={6}  key={field.QuestionId + index}>
									<FormControl variant="standard" fullWidth sx={{  }}>
										{renderPopover(field)}
										<TextField
											className='color-default'
											{...commonProps}
											onChange={e => handleChange(index, e.target.value)}
											inputProps={{ maxLength: 100 }}
											label={('')}
										/>
									</FormControl>
								</Grid>
							);

						case 'number':
							return (
								<Grid item xs={12} md={6} key={field.QuestionId + index}>
									<FormControl variant="standard" fullWidth sx={{  }}>
										{renderPopover(field)}
										<NumericFormat
											className='color-default'
											{...commonProps}
											onChange={e => handleChange(index, e.target.value)}
											decimalScale={2}
											customInput={TextField}
											label={('')}
										/>
									</FormControl>
								</Grid>
							);

						case 'list':
							return (
								<Grid item xs={12} md={index === 0 ? 12 : 6}  key={field.QuestionId + index}>
									<FormControl fullWidth sx={{  }}>
										{renderPopover(field)}
										<LazyAutocomplete 
											field={field} 
											language={currentLanguage} 
											handleChange={handleChange}
											index={index} 
											commonProps={{
												...commonProps,
												label: ('')
											}} 
											handleOnBlur={handleOnBlur} 
										/>
									</FormControl>
								</Grid>
							);

						default:
							return null;
					}
				})}
			</Grid>
		</Box>
	);
};

export default DynamicFormField;